var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicPlaceholderSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9041_6229)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    rx: 4,
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.0002 22.4374C16.0771 22.4374 18.5716 19.4762 18.5716 15.8235C18.5716 12.1706 17.7526 9.20947 13.0002 9.20947C8.24785 9.20947 7.42871 12.1706 7.42871 15.8235C7.42871 19.4762 9.92322 22.4374 13.0002 22.4374Z",
    fill: "#686868"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.287 32.3419C23.1861 25.9256 22.3539 24.0973 15.9858 22.9399C15.9858 22.9399 15.0894 24.0902 13.0001 24.0902C10.9108 24.0902 10.0142 22.9399 10.0142 22.9399C3.71566 24.0846 2.83288 25.8858 2.7168 32.1335C2.70729 32.6436 2.70287 32.6704 2.70117 32.6112C2.70156 32.7222 2.7168 36.0004 2.7168 36.0004H12.9999H23.2986C23.2986 36.0004 23.2983 32.8955 23.2986 32.7867C23.2969 32.8233 23.2935 32.7523 23.287 32.3419Z",
    fill: "#686868"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9041_6229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 36,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicPlaceholderSm);
export default __webpack_public_path__ + "static/media/profile-pic-placeholder-sm.a62de1d7e096869261155670e848e780.svg";
export { ForwardRef as ReactComponent };